import script from "./VoiceCallRetriggerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceCallRetriggerDialog.vue?vue&type=script&setup=true&lang=js"

import "./VoiceCallRetriggerDialog.vue?vue&type=style&index=0&id=07ad6146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ad6146"]])

export default __exports__